module.exports = __webpack_public_path__ + "img/ScuolaSmart_Carousel_1920x450_B2C.1e861324.jpg";